var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3 8.5H17.4V4H6.6V8.5H5.7C4.206 8.5 3 9.706 3 11.2V16.6H6.6V20.2H17.4V16.6H21V11.2C21 9.706 19.794 8.5 18.3 8.5ZM8.4 5.8H15.6V8.5H8.4V5.8ZM15.6 18.4V14.8H8.4V18.4H15.6ZM17.4 14.8V13H6.6V14.8H4.8V11.2C4.8 10.705 5.205 10.3 5.7 10.3H18.3C18.795 10.3 19.2 10.705 19.2 11.2V14.8H17.4ZM16.5 11.65C16.5 11.1529 16.9029 10.75 17.4 10.75C17.8971 10.75 18.3 11.1529 18.3 11.65C18.3 12.1471 17.8971 12.55 17.4 12.55C16.9029 12.55 16.5 12.1471 16.5 11.65Z",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboPrint);
export default __webpack_public_path__ + "static/media/FBOPrint.e3f567d21eccba2e9263359bab935c95.svg";
export { ForwardRef as ReactComponent };